module.exports = __webpack_public_path__ + "static/media/priceImage0.f83a4c9b.svg";